/* eslint-disable no-unused-vars */
import {
    useContext
} from 'react';
import '../KBStyles.css';
import {
    SidebarContext
} from '../knowledgeBuilderContext/KBSidebarContext';
import {
    Input
} from 'shared/components/ui/input';
import {
    Button
} from 'shared/components/ui/button';
import KBDropdown from './KBDropdown';
import {
    Switch
} from 'shared/components/ui/switch';
import LabelWithTooltip from './LabelWithTooltip';
import {
    SEARCH_TYPE_OPTIONS
} from '../config/dropdownOptions';
import LoadingLine from './LoadingLine/LoadingLine';
export default function QueryInterface() {
    const {
        searchQuery,
        setSearchQuery,
        rerank,
        setRerank,
        searchType,
        setSearchType,
        setTopK,
        setTopN,
        topN,
        topK,
        queryLoading,
        resetQueryResults,
        sendQuery,
        setSelectedQuery
    } = useContext(SidebarContext);

    return (
        <>
            <div className="relative border rounded-lg p-4 bg-card mb-4">
                <div className="flex gap-4 p-2 items-end">
                    <div className="flex-grow space-y-1">
                        <LabelWithTooltip label="Query" />
                        <Input placeholder="Query documents here" type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="h-9" />
                    </div>

                    <div className="min-w-[160px] flex flex-col justify-end gap-1">
                        <KBDropdown className="!mb-0" triggerClassName="h-9" selectedValue={searchType} required setter={setSearchType} options={() => SEARCH_TYPE_OPTIONS} title="Search type" />
                    </div>

                    <div className="pb-0">
                        <Button disabled={!searchType} onClick={sendQuery} className="h-9 px-4">Send Query</Button>
                    </div>

                    <div className="space-y-1">
                        <LabelWithTooltip label="Top K" />
                        <Input onChange={(e) => setTopK(Math.abs(e.target.value) || 1)} value={topK} type="number" min="1" className="text h-9 w-20" />
                    </div>

                    <div className="space-y-1 flex flex-col justify-between h-[60px]">
                        <LabelWithTooltip label="Use Rerank" tooltipText="Reranks the results." />
                        <div className="flex items-center h-9">
                            <Switch onCheckedChange={(e) => setRerank(e)} />
                        </div>
                    </div>

                    {rerank && <div className="space-y-1">
                        <LabelWithTooltip label="Top N" />
                        <Input value={topN} onChange={(e) => setTopN(Math.abs(e.target.value) || 1)} type="number" min="1" className="text h-9 w-20" />
                    </div>}
                </div>
                {queryLoading && <LoadingLine position="bottom" />}
            </div>

        </>
    );
}